import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plane, TrendingUp, Plus, MapPin } from "lucide-react";
import { StatusBadge, Spinner, EmptyState } from "../components/common";
import api, { apiError } from "../lib/api";
import { rupiah, fmtDate } from "../lib/format";
import { useI18n } from "../lib/i18n";

export default function MyTrips() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/trips/mine").then((r) => setTrips(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const boost = async (id) => { try { await api.post(`/trips/${id}/boost`); toast.success("Trip di-boost! 🚀"); load(); } catch (e) { toast.error(apiError(e)); } };
  const cancel = async (id) => { try { await api.patch(`/trips/${id}/cancel`); toast.success("Trip dibatalkan"); load(); } catch (e) { toast.error(apiError(e)); } };

  if (loading) return <Spinner />;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="font-heading font-extrabold text-2xl text-navy">{t("nav_trips")}</h1>
        <button onClick={() => navigate("/post-trip")} data-testid="new-trip-btn"
          className="rounded-full bg-lime hover:bg-lime-dark text-navy font-bold px-4 py-2.5 text-sm flex items-center gap-1.5 transition-colors">
          <Plus size={16} /> New Trip
        </button>
      </div>
      {trips.length === 0 ? (
        <EmptyState icon={Plane} title="Belum ada trip" subtitle="Posting trip pertamamu untuk mulai menerima request."
          action={<button onClick={() => navigate("/post-trip")} data-testid="trips-empty-cta" className="rounded-full bg-lime text-navy font-bold px-5 py-2.5 text-sm">{t("post_trip")}</button>} />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {trips.map((tr) => (
            <div key={tr.id} className="bg-white rounded-3xl p-5 shadow-soft border border-black/5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 font-heading font-bold text-navy"><MapPin size={16} className="text-sky" /> {tr.from_city} → {tr.to_city}</div>
                <StatusBadge status={tr.status} />
              </div>
              <div className="mt-2 text-sm text-muted-foreground flex flex-wrap gap-3">
                <span className="flex items-center gap-1"><Plane size={14} /> {fmtDate(tr.departure_date)}</span>
                <span>{tr.capacity_kg}kg</span>
                <span className="font-semibold text-ink">{rupiah(tr.service_fee)}/item</span>
              </div>
              {tr.status === "active" && (
                <div className="flex gap-2 mt-4">
                  {!tr.boosted ? (
                    <button onClick={() => boost(tr.id)} data-testid={`boost-${tr.id}`}
                      className="flex-1 rounded-full bg-lime-light text-navy font-bold py-2 text-xs flex items-center justify-center gap-1"><TrendingUp size={14} /> Boost</button>
                  ) : <span className="flex-1 text-center text-xs font-bold text-lime-dark py-2 flex items-center justify-center gap-1"><TrendingUp size={14} /> Boosted</span>}
                  <button onClick={() => cancel(tr.id)} data-testid={`cancel-trip-${tr.id}`}
                    className="flex-1 rounded-full bg-white border border-black/10 text-navy font-bold py-2 text-xs">Cancel</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
